export default import.meta.ROLLUP_FILE_URL_drF$4ORQ$rdeyGTv8hZYUA